var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#121212"}},[_c('Cabecalho'),_c('v-main',[_c('CarouselBanner'),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('div',{attrs:{"id":"inicio-conteudo"}},[_c('router-view')],1)])],1),_c('Rodape'),_c('WhatsAppButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }